module.exports = __webpack_public_path__ + "img/ventas.280fff47.png";